export default "__VITE_ASSET__DC5t3H57__"